import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { FormattedMessage, injectIntl } from 'react-intl'
import { connect } from 'react-redux'
import { Link } from 'react-router-dom'
import { push } from 'react-router-redux'
import Notifications from 'react-notification-system-redux'
import validator from 'validator'
import { Modal, Tabs, Tab } from 'react-bootstrap'

import { ConfirmDialog } from '../../../common/confirm_dialog'
import * as formatters from '../../../common/formatters'
import { Form, InputField, SelectField, CheckboxField, SubmitButton } from '../../../common/form'
import { url, handleCommonEditActions, validationMessage, getPrerequisitesArray } from '../../../common/helpers'
import { LoadingOverlay } from '../../../common/loading_overlay'

import { preparePrerequisitesFetchStatusSelectors } from '../../../common/prerequisites/selectors'
import { preparePrerequisitesActionCreators } from '../../../common/prerequisites/actionCreators'

import * as carriersActionCreators from '../actionCreators'
import {
    createGetCarrierByIDSelector,
    createGetCurrentCarrierStatusSelector,
    getInfoByVATLoading,
    createGetInfoByVATSelector,
    createGetDuplicitySelector,
    getCarrierDuplicityChecking,
    getCarrierDuplicityCheckingData,
    getCarrierDuplicityCheckingError,
} from '../selectors'

import PermissionsCheck from '../../auth/components/PermissionsCheck'
import { PERMS } from '../permissions'

import CarriersContactsList from './CarriersContactsList'

const componentIdentifier = 'carriers_edit'
const prerequisites = ['countries']

class CarriersEdit extends Component {
    defaultValues = {}

    validationRules = {
        name: value => validator.isEmpty(String(value)) && validationMessage('isEmpty'),
    }

    state = {
        values: this.defaultValues,
        modalDuplicity: {
            show: false,
            duplicity: null,
        },
        carrierContacts: {
            show: true,
        },
        duplicityFound: false,
        confirmDialog: {
            show: false,
            title: '',
            message: '',
            labelCancel: '',
            labelAccept: '',
            classNameAccept: 'text-success',
            classNameCancel: 'text-default',
            onCancel: () => {},
            onAccept: () => {},
        },
    }

    setValues = (values, callback) => {
        this.setState(
            {
                values,
            },
            callback
        )
    }

    handleChangeValues = values => {
        if (values.vat_number !== this.state.values.vat_number) {
            this.checkDuplicity(values.vat_number)
        }

        this.setValues(values)
    }

    handleSubmit = values => {
        this.setValues(values, () => {
            this.handleSave(false)
        })
    }

    save = ignoreDuplicity => {
        this.props.actions.saveCarrier(this.state.values, ignoreDuplicity)
    }

    duplicityFoundCallback = duplicity => {
        this.setState({
            modalDuplicity: {
                show: true,
                duplicity,
            },
        })
    }

    handleDuplicityCancel = () => {
        this.setState({
            modalDuplicity: {
                show: false,
                duplicity: null,
            },
        })
    }

    handleDuplicityConfirm = () => {
        this.handleDuplicityCancel()
        this.save(true)
    }

    handleVatNumberSearch = () => {
        if (this.state.values && this.state.values.vat_number) {
            this.props.actions.loadInfoByVATNumber(this.state.values.vat_number)
        }
    }

    handleSelectTab = tabKey => {
        if (tabKey === 1) {
            this.loadCarrierContacts()
        }
    }

    loadCarrierContacts = () => {
        this.setState({
            carrierContacts: {
                show: true,
            },
        })
    }

    successCallback = null

    handleSave = () => {
        this.successCallback = (props, nextProps) => {
            if (nextProps.status.get('id')) {
                props.redirect(url(props.match, `carriers/${nextProps.status.get('id')}`))
            } else {
                props.redirect(url(props.match, 'carriers'))
            }
        }

        this.save()
    }

    handleSaveAndClose = () => {
        this.successCallback = props => {
            props.redirect(url(props.match, 'carriers'))
        }

        this.save()
    }

    checkDuplicity = vatNumber => {
        this.props.actions.checkCarrierDuplicity({
            vat_number: vatNumber,
            id: this.props.match.params.carrierID,
        })
    }

    checkDuplicityCallback = data => {
        if (data.duplicity_found) {
            this.props.notify(
                {
                    title: this.props.intl.formatMessage({ id: 'alerts.titles.warning' }),
                    message: this.props.intl.formatMessage({ id: 'alerts.messages.duplicityFound' }),
                    position: 'tc',
                },
                'error'
            )
        }
        this.setState({
            duplicityFound: data.duplicity_found,
        })
    }


    // restore
    handleRestore = () => {
        this.showConfirmDialog({
            title: this.props.intl.formatMessage({ id: 'confirmDialog.itemRestore.title' }),
            message: this.props.intl.formatMessage({ id: 'confirmDialog.itemRestore.message' }),
            labelCancel: this.props.intl.formatMessage({ id: 'confirmDialog.itemRestore.cancel' }),
            labelAccept: this.props.intl.formatMessage({ id: 'confirmDialog.itemRestore.accept' }),
            classNameAccept: 'btn-success',
            onAccept: () => {
                this.props.actions.restoreCarrier(this.props.carrier.id)
                this.hideConfirmDialog()
            },
        })
    }

    // confirm dialog
    showConfirmDialog = options => {
        this.setState({
            confirmDialog: {
                show: true,
                title: options.title || this.props.intl.formatMessage({ id: 'confirmDialog.default.title' }),
                message: options.message || this.props.intl.formatMessage({ id: 'confirmDialog.default.message' }),
                labelCancel: options.labelCancel || this.props.intl.formatMessage({ id: 'confirmDialog.default.cancel' }),
                labelAccept: options.labelAccept || this.props.intl.formatMessage({ id: 'confirmDialog.default.accept' }),
                classNameAccept: options.classNameAccept || 'btn-success',
                classNameCancel: options.classNameCancel || 'btn-default',
                onCancel: options.onCancel || this.hideConfirmDialog,
                onAccept: options.onAccept || this.hideConfirmDialog,
            },
        })
    }

    hideConfirmDialog = () => {
        this.setState({
            confirmDialog: {
                show: false,
                onCancel: () => {},
                onAccept: () => {},
            },
        })
    }

    componentDidMount() {
        this.props.match.params.carrierID && this.props.actions.fetchCarrier(this.props.match.params.carrierID)
        this.props.actions.clearInfoByVATNumber()
        this.props.actions.fetchPrerequisites()
    }

    componentWillReceiveProps(nextProps) {
        handleCommonEditActions(this.props, nextProps, this.successCallback, this.duplicityFoundCallback)

        if (nextProps.carrier && (JSON.stringify(nextProps.carrier) !== JSON.stringify(this.props.carrier) || !this.state.values.id)) {
            this.setValues(nextProps.carrier.toJS())
        }

        if (nextProps.getInfoByVAT && JSON.stringify(nextProps.getInfoByVAT) !== JSON.stringify(this.props.getInfoByVAT)) {
            const newValues = {
                ...this.state.values,
            }

            if (nextProps.getInfoByVAT.name) {
                newValues.name = nextProps.getInfoByVAT.name
            }

            if (nextProps.getInfoByVAT.street) {
                newValues.street = nextProps.getInfoByVAT.street
            }

            if (nextProps.getInfoByVAT.city) {
                newValues.city = nextProps.getInfoByVAT.city
            }

            if (nextProps.getInfoByVAT.zipcode) {
                newValues.zipcode = nextProps.getInfoByVAT.zipcode
            }

            if (nextProps.getInfoByVAT.country_id) {
                newValues.country_id = nextProps.getInfoByVAT.country_id
            }

            if (nextProps.getInfoByVAT.reg_number) {
                newValues.reg_number = nextProps.getInfoByVAT.reg_number
            }

            this.setValues(newValues)
        }

        if (this.props.getDuplicityChecking && !nextProps.getDuplicityChecking && !nextProps.getDuplicityCheckingError) {
            this.checkDuplicityCallback(nextProps.getDuplicityCheckingData)
        }
    }

    render() {
        document.title = formatters.titleFormatter(this.props.intl.formatMessage({ id: 'modules.carriers.heading' }))

        const carrier = this.props.carrier
        const duplicity = this.props.duplicity

        const mainColClassName = carrier ? 'col-lg-4' : 'col-md-8 col-md-offset-2 col-lg-6 col-lg-offset-3 col-xl-4 col-xl-offset-4'

        return (
            <PermissionsCheck hasAny={Object.values(PERMS)} noPermissionsPage>
                <div className="page-inner">
                    <div id="main-wrapper">
                        <div className="row hp-100">
                            <div className={mainColClassName} style={{ paddingRight: '0' }}>
                                <div className="panel panel-white">
                                    <div className="panel-body panel-padding">
                                        <div className="panel-head">
                                            <h4>
                                                <FormattedMessage id="modules.carriers.heading" /> -{' '}
                                                {this.props.carrier ? (
                                                    <FormattedMessage id="fields.itemEdit" />
                                                ) : (
                                                    <FormattedMessage id="fields.itemCreate" />
                                                )}
                                            </h4>
                                        </div>
                                        <LoadingOverlay
                                            active={
                                                this.props.prerequisites.status.get('fetching') ||
                                                this.props.status.get('fetching') ||
                                                this.props.status.get('saving') ||
                                                this.props.loadingInfoByVAT
                                            }
                                        >
                                            <PermissionsCheck hasAny={Object.values(PERMS)}>
                                                <Form
                                                    values={this.state.values}
                                                    validationRules={this.validationRules}
                                                    onChange={this.handleChangeValues}
                                                    onSubmit={this.handleSubmit}
                                                    isEdit={Boolean(this.props.carrier)}
                                                >

                                                    {carrier && carrier.deleted_at && (
                                                        <div className="row">
                                                            <div className="col-lg-12">
                                                                <div className="alert alert-danger m-b-lg">
                                                                    <div className="row">
                                                                        <div className="col-sm-8">
                                                                            <p className="no-m">
                                                                                <FormattedMessage id="alerts.messages.warningDeleted" />
                                                                            </p>
                                                                        </div>
                                                                        <PermissionsCheck has={[PERMS.RESTORE]}>
                                                                            <div className="col-sm-4 text-right">
                                                                                <button onClick={this.handleRestore} type="button" className="btn btn-danger">
                                                                                    <FormattedMessage id="buttons.restore" />
                                                                                </button>
                                                                            </div>
                                                                        </PermissionsCheck>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    )}

                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <div className={`form-group ${this.state.duplicityFound ? 'has-error' : ''}`}>
                                                                <label htmlFor="vat_number">
                                                                    <FormattedMessage id="fields.vatNumber" />
                                                                </label>
                                                                <div className="input-group">
                                                                    <InputField id="vat_number" />
                                                                    <span className="input-group-btn">
                                                                        <button
                                                                            onClick={this.handleVatNumberSearch}
                                                                            className="btn btn-default"
                                                                            type="button"
                                                                        >
                                                                            <span className="far fa-search" />
                                                                        </button>
                                                                    </span>
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="reg_number"
                                                                label={this.props.intl.formatMessage({ id: 'fields.regNumber' })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <InputField
                                                        id="name"
                                                        label={this.props.intl.formatMessage({ id: 'fields.carrierName' })}
                                                        formGroupClassName="form-group-bigger"
                                                    />

                                                    <h4 className="m-t-lg wp-100">
                                                        <FormattedMessage id="fields.invoicingAddress" />
                                                    </h4>
                                                    <InputField id="street" label={this.props.intl.formatMessage({ id: 'fields.street' })} />
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <InputField
                                                                id="zipcode"
                                                                label={this.props.intl.formatMessage({ id: 'fields.zipcode' })}
                                                            />
                                                        </div>
                                                        <div className="col-md-8">
                                                            <InputField id="city" label={this.props.intl.formatMessage({ id: 'fields.city' })} />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-4">
                                                            <SelectField
                                                                id="country_id"
                                                                label={this.props.intl.formatMessage({ id: 'fields.country' })}
                                                                values={getPrerequisitesArray(
                                                                    this.props.prerequisites.values.get('countries'),
                                                                    'id',
                                                                    'iso_code'
                                                                )}
                                                            />
                                                        </div>
                                                    </div>

                                                    <h4 className="m-t-lg wp-100">
                                                        <FormattedMessage id="fields.contacts" />
                                                    </h4>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <InputField id="email" label={this.props.intl.formatMessage({ id: 'fields.email' })} />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <InputField id="phone" label={this.props.intl.formatMessage({ id: 'fields.phone' })} />
                                                        </div>
                                                    </div>

                                                    <h4 className="m-t-lg wp-100">
                                                        <FormattedMessage id="fields.invoicingSettings" />
                                                    </h4>
                                                    <div className="row">
                                                        <div className="col-md-3">
                                                            <CheckboxField
                                                                id="vat_payer"
                                                                label={this.props.intl.formatMessage({ id: 'fields.vatPayer' })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="invoice_deadline_days"
                                                                label={this.props.intl.formatMessage({ id: 'fields.defaultDeadline' })}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="email_for_invoicing"
                                                                label={this.props.intl.formatMessage({ id: 'fields.invoicingEmail' })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="bank_account"
                                                                label={this.props.intl.formatMessage({ id: 'fields.bankAccount' })}
                                                            />
                                                        </div>
                                                        <div className="col-md-3">
                                                            <InputField
                                                                id="bank_code"
                                                                label={this.props.intl.formatMessage({ id: 'fields.bankCode' })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="bank_account_iban"
                                                                label={this.props.intl.formatMessage({ id: 'fields.bankAccountIBAN' })}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="bank_account_swift"
                                                                label={this.props.intl.formatMessage({ id: 'fields.bankAccountSWIFT' })}
                                                            />
                                                        </div>
                                                    </div>

                                                    <h4 className="m-t-lg wp-100">
                                                        <FormattedMessage id="fields.limitsAndBlocking" />
                                                    </h4>
                                                    <div className="row">
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="limit_unpaid_invoices"
                                                                label={this.props.intl.formatMessage({ id: 'fields.limitUnpaidInvoices' })}
                                                            />
                                                        </div>
                                                        <div className="col-md-6">
                                                            <InputField
                                                                id="limit_overdue_invoices"
                                                                label={this.props.intl.formatMessage({ id: 'fields.limitOverdueInvoices' })}
                                                            />
                                                        </div>
                                                    </div>
                                                    <CheckboxField id="is_blocked" label={this.props.intl.formatMessage({ id: 'fields.blocked' })} />

                                                    <div className="btns-form">
                                                        <Link to={url(this.props.match, 'carriers')} className="btn btn-addon btn-default">
                                                            <i className="far fa-chevron-left" /> <FormattedMessage id="buttons.back" />
                                                        </Link>
                                                        {carrier && (
                                                            <SubmitButton
                                                                saveAndClose
                                                                onClick={this.handleSaveAndClose}
                                                                isEdit={Boolean(this.props.carrier)}
                                                                perms={[PERMS.CREATE, PERMS.UPDATE]}
                                                                className="btn-addon pull-right"
                                                                disabled={this.state.duplicityFound || this.props.getDuplicityChecking}
                                                            />
                                                        )}
                                                        <SubmitButton
                                                            type="button"
                                                            onClick={this.handleSave}
                                                            isEdit={Boolean(this.props.carrier)}
                                                            perms={[PERMS.CREATE, PERMS.UPDATE]}
                                                            className="btn-addon pull-right m-r-xs"
                                                            disabled={this.state.duplicityFound || this.props.getDuplicityChecking}
                                                        />
                                                    </div>
                                                </Form>
                                            </PermissionsCheck>
                                        </LoadingOverlay>
                                    </div>
                                </div>
                            </div>

                            {carrier && (
                                <div className="col-lg-8 hp-100" style={{ paddingLeft: '5px' }}>
                                    <div className="panel panel-white hp-100 m-b-no">
                                        <div className="panel-body panel-padding hp-100">
                                            <Tabs
                                                defaultActiveKey={1}
                                                animation={false}
                                                id="detail-tabs"
                                                className="detail-tabs"
                                                onSelect={this.handleSelectTab}
                                            >
                                                <Tab
                                                    eventKey={1}
                                                    title={
                                                        <span>
                                                            <i className="far fa-user m-r-xxs" />
                                                            {this.props.intl.formatMessage({ id: 'fields.contacts' })}
                                                        </span>
                                                    }
                                                >
                                                    {this.state.carrierContacts.show && <CarriersContactsList carrier={carrier} />}
                                                </Tab>
                                            </Tabs>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </div>
                    </div>

                    <Modal show={Boolean(this.state.modalDuplicity.show)} onHide={this.handleDuplicityCancel} bsSize="sm">
                        <Modal.Header closeButton>
                            <Modal.Title>
                                <FormattedMessage id="confirmDialog.duplicityFound.title" />
                            </Modal.Title>
                        </Modal.Header>
                        <Modal.Body>
                            <FormattedMessage id="confirmDialog.duplicityFound.message" />
                            {duplicity && (
                                <div>
                                    <div className="row m-t-lg">
                                        <div className="col-sm-4">
                                            <FormattedMessage id="fields.vatNumber" />:
                                        </div>
                                        <div className="col-sm-8 text-right">
                                            <strong>{duplicity.vat_number}</strong>
                                        </div>
                                    </div>
                                    <hr className="tiny" />
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <FormattedMessage id="fields.name" />:
                                        </div>
                                        <div className="col-sm-8 text-right">
                                            <strong>{duplicity.name}</strong>
                                        </div>
                                    </div>
                                    <hr className="tiny" />
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <FormattedMessage id="fields.address" />:
                                        </div>
                                        <div className="col-sm-8 text-right">
                                            <strong>{duplicity.address}</strong>
                                        </div>
                                    </div>
                                    <hr className="tiny" />
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <FormattedMessage id="fields.email" />:
                                        </div>
                                        <div className="col-sm-8 text-right">
                                            <strong>{duplicity.email}</strong>
                                        </div>
                                    </div>
                                    <hr className="tiny" />
                                    <div className="row">
                                        <div className="col-sm-4">
                                            <FormattedMessage id="fields.phone" />:
                                        </div>
                                        <div className="col-sm-8 text-right">
                                            <strong>{duplicity.phone}</strong>
                                        </div>
                                    </div>
                                </div>
                            )}
                        </Modal.Body>
                        <Modal.Footer>
                            <button className="btn btn-success m-r-xs" onClick={this.handleDuplicityConfirm}>
                                <FormattedMessage id="confirmDialog.duplicityFound.accept" />
                            </button>
                            <button className="btn btn-default" onClick={this.handleDuplicityCancel}>
                                <FormattedMessage id="confirmDialog.duplicityFound.cancel" />
                            </button>
                        </Modal.Footer>
                    </Modal>
                </div>
                <ConfirmDialog options={this.state.confirmDialog} />
            </PermissionsCheck>
        )
    }
}

function mapStateToProps(state, ownProps) {
    return {
        carrier: createGetCarrierByIDSelector(ownProps.match.params.carrierID)(state),
        status: createGetCurrentCarrierStatusSelector()(state),
        duplicity: createGetDuplicitySelector()(state),
        prerequisites: preparePrerequisitesFetchStatusSelectors(componentIdentifier, prerequisites, state),
        loadingInfoByVAT: getInfoByVATLoading(state),
        getInfoByVAT: createGetInfoByVATSelector()(state),
        getDuplicityChecking: getCarrierDuplicityChecking(state),
        getDuplicityCheckingError: getCarrierDuplicityCheckingError(state),
        getDuplicityCheckingData: getCarrierDuplicityCheckingData(state),
    }
}

function mapDispatchToProps(dispatch) {
    return {
        actions: {
            ...bindActionCreators(
                {
                    ...carriersActionCreators,
                    ...preparePrerequisitesActionCreators(componentIdentifier, prerequisites),
                },
                dispatch
            ),
        },
        redirect: toURL => dispatch(push(toURL)),
        notify: (notification, type) => dispatch(Notifications.show(notification, type)),
    }
}

export default injectIntl(
    connect(
        mapStateToProps,
        mapDispatchToProps
    )(CarriersEdit)
)
